var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 20.8333H29.1667V4.16667C29.1667 3.0616 28.7277 2.00179 27.9463 1.22039C27.1649 0.438988 26.1051 0 25 0C23.8949 0 22.8351 0.438988 22.0537 1.22039C21.2723 2.00179 20.8333 3.0616 20.8333 4.16667V20.8333H4.16667C3.0616 20.8333 2.00179 21.2723 1.22039 22.0537C0.438988 22.8351 0 23.8949 0 25C0 26.1051 0.438988 27.1649 1.22039 27.9463C2.00179 28.7277 3.0616 29.1667 4.16667 29.1667H20.8333V45.8333C20.8333 46.9384 21.2723 47.9982 22.0537 48.7796C22.8351 49.561 23.8949 50 25 50C26.1051 50 27.1649 49.561 27.9463 48.7796C28.7277 47.9982 29.1667 46.9384 29.1667 45.8333V29.1667H45.8333C46.9384 29.1667 47.9982 28.7277 48.7796 27.9463C49.561 27.1649 50 26.1051 50 25C50 23.8949 49.561 22.8351 48.7796 22.0537C47.9982 21.2723 46.9384 20.8333 45.8333 20.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus-white.5772564ac2e50855d3619f7556c0248d.svg";
export { ForwardRef as ReactComponent };